import Head from 'next/head';
import Image from 'next/legacy/image';
import { WEBSITE_NAME } from '@lib/constants';
import { BodyRegular, H1 } from '@components/atoms/typography';
import Button from '@components/atoms/button';
import { buildLoginHref } from '@lib/auth0/login-url';

const HUB_PATH = '/welcome';

const WelcomeLogin = () => (
  <div>
    <Head>
      <title>
        {'Welcome | '}
        {WEBSITE_NAME}
      </title>
    </Head>
    <main>
      <div className="bg-white flex flex-col justify-center py-[50px] sm:px-6 lg:px-8">
        <div className="flex justify-center mb-5 px-5">
          <Image
            src="/images/football-boots.png"
            height={250}
            width={500}
            priority
            alt="Football boots on a football pitch"
          />
        </div>

        <div className="flex flex-col items-center justify-center px-3">
          <H1 className="text-center">
            Welcome to Fantasy Football Hub <span className="ml-1">🎉</span>
          </H1>
          <BodyRegular>Thanks for being one of our subscribers</BodyRegular>
        </div>
        <div className="flex justify-center items-center mt-5">
          <Button href={buildLoginHref(HUB_PATH)} variant="primary">
            Click here to log in
          </Button>
        </div>
      </div>
    </main>
  </div>
);

export default WelcomeLogin;
